import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
export function initToastification(app) {
    const options = {
        // You can set your default options here
        toastClassName: 'moba-toast',
        containerClassName: 'moba-toast__container',
        position: POSITION.TOP_CENTER,
        timeout: false,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: false,
        closeButton: false,
        icon: true,
        rtl: false,
        filterBeforeCreate: (toast, toasts) => {
            if (toasts.filter((t) => {
                return t.type === toast.type;
            }).length !== 0) {
                // Returning false discards the toast
                return false;
            }
            // You can modify the toast if you want
            return toast;
        }
    };
    app.use(Toast, options);
}
